import { IPlayerStatistics } from "@data-types/sport-stats/SportStatsTypes";
import { observer } from "mobx-react";
import React from "react";
import { useTranslation } from "react-i18next";

export default observer(function PlayerStatisticsTemplate({
	data,
}: {
	data?: IPlayerStatistics["data"];
}) {
	const { t } = useTranslation();

	return (
		<div className="card--players__data">
			<TableRow
				title={`${t(
					"EVENT.STATISTICS.MATCH_STATS.expectedGoals.TITLE"
				)} (xG)`}
				data={formatNumber(data?.expectedGoals)}
			/>
			<TableRow title={t("EVENT.STATISTICS.GOALS")} data={data?.goals} />
			<TableRow
				title={t("EVENT.STATISTICS.PLAYER_STATS.SCORING_FREQUENCY")}
				data={formatNumber(data?.scoringFrequency)}
			/>
			<TableRow
				title={t("EVENT.STATISTICS.PLAYER_STATS.APPEARANCES")}
				data={formatNumber(data?.appearances)}
			/>
			<TableRow
				title={t("EVENT.STATISTICS.PLAYER_STATS.MATCHES_STARTED")}
				data={formatNumber(data?.matchesStarted)}
			/>
			<TableRow
				title={t("EVENT.STATISTICS.PLAYER_STATS.SUBBED_ON")}
				data={formatNumber(data?.subbedOn)}
			/>
		</div>
	);
});

function TableRow({ title, data }: { title: string; data?: number }) {
	if (data == null) {
		return null;
	}
	return (
		<div className="card--players__row">
			<span className="card--players__col card--players__label">
				{title}
			</span>
			<span className="card--players__col card--players__value">
				{data}
			</span>
		</div>
	);
}

const formatNumber = (value?: number) => {
	return typeof value === "number" ? parseFloat(value.toFixed(2)) : value;
};
